module.exports = __webpack_public_path__ + "static/media/aftereffects.b9e1eddd.svg";